export default __webpack_public_path__ + "static/media/pic_ai_1.bff7d351.png";